<script>
import toasts from "../../mixins/toasts";

export default Vue.extend({
  mixins: [toasts],
  props: {
    classrooms: Array
  },
  data() {
    return {
      endpoint: "/api/classrooms",
      items: [],
      modal: {
        fresh: true,
        active: false,
        modified: false,
        item: {
          name: null
        }
      },
      messages: {
        remove: {
          title: "Удаление аудитории",
          message: "Вы действительно хотите удалить данную аудиторию?",
          confirm: "Удалить аудиторию",
          cancel: "Отмена",
          success: "Аудитория была успешно удалена"
        }
      }
    };
  },
  created() {
    this.items = this.classrooms;
  },
  methods: {
    open(item) {
      this.modal.fresh = item == null;
      if (item) {
        this.modal.item = JSON.parse(JSON.stringify(item));
      } else {
        this.modal.item = {
          name: null
        };
      }
      this.modal.active = true;
    },
    close() {
      this.modal.active = false;
    },
    save(item) {
      let loading = this.$loading.open();

      let request;

      if (this.modal.fresh) {
        request = axios.post(`${this.endpoint}`, item);
      } else {
        request = axios.put(`${this.endpoint}/${item.id}`, item);
      }

      request
        .then(response => {
          axios
            .get(`${this.endpoint}`)
            .then(response => {
              this.items = response.data;
              this.modal.active = false;
              loading.close();
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        })
        .catch(error => {
          switch (error.response.status) {
            case 500: {
              this.toast("error", "@unexpected", error);
              break;
            }
            default: {
              this.toast("warning", _.first(error.response.data.errors.name));
            }
          }
          loading.close();
        });
    },
    remove(item) {
      this.$dialog.confirm({
        title: this.messages.remove.title,
        message: this.messages.remove.message,
        confirmText: this.messages.remove.confirm,
        cancelText: this.messages.remove.cancel,
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .delete(`${this.endpoint}/${item.id}`)
            .then(response => {
              _.remove(this.items, {
                id: item.id
              });
              this.modal.active = false;
              loading.close();
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        }
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/classrooms/Index.vue